import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Option } from './Option';
import styles from './Menu.module.css';
import messages from './SelectWithSearch.messages';

export class Menu extends Component {
    renderMenuHeader = () => {
        const { header, switchPosition, switchText, onHeaderClick } =
            this.props;
        return switchPosition === 'top' ? (
            <div className={styles.switchEntryType}>
                {header}{' '}
                <button className={styles.link} onClick={onHeaderClick}>
                    {switchText}
                </button>
            </div>
        ) : (
            <div>{header}</div>
        );
    };

    renderMenuOptions = () => {
        const { items, optionRenderer, selectItem } = this.props;
        return items.map((item, index) => {
            return (
                <Option
                    onClick={selectItem.bind(null, item)}
                    optionRenderer={optionRenderer}
                    key={index}
                    item={item}
                />
            );
        });
    };

    renderNoResultsMenu = () => {
        const {
            handleMouseDownOnMenu,
            searchTerm,
            noSearchTermRenderer,
            noResultsRenderer
        } = this.props;

        let container = (
            <div className={styles.noResultsTitle}>
                <FormattedMessage {...messages.noResultsFound} />
            </div>
        );
        if (noResultsRenderer) {
            container = noResultsRenderer(searchTerm);
        }

        if (noSearchTermRenderer) {
            container = noSearchTermRenderer();
        }

        return (
            <div
                className={styles.noResults}
                onMouseDown={handleMouseDownOnMenu}
            >
                {container}
            </div>
        );
    };

    renderMenu = () => {
        const { handleMouseDownOnMenu } = this.props;
        return (
            <div className={styles.Menu} onMouseDown={handleMouseDownOnMenu}>
                {this.renderMenuHeader()}
                {this.renderMenuOptions()}
            </div>
        );
    };

    render() {
        const { items } = this.props;
        return items.length ? this.renderMenu() : this.renderNoResultsMenu();
    }
}
